import { useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/hooks/use-toast";

export const useEmailSubscription = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { toast } = useToast();

  const subscribeToEmail = async (email: string) => {
    try {
      setIsLoading(true);
      
      const { error } = await supabase
        .from("email_subscriptions")
        .insert([{ email }]);

      if (error) {
        if (error.code === "23505") { // Unique constraint violation
          toast({
            title: "Already subscribed!",
            description: "This email is already subscribed to daily tips.",
            variant: "destructive",
          });
          return { success: false };
        }
        throw error;
      }

      toast({
        title: "Successfully subscribed!",
        description: "You'll receive daily tips in your inbox.",
      });
      
      return { success: true };
    } catch (error) {
      console.error("Error subscribing to email:", error);
      toast({
        title: "Subscription failed",
        description: "Please try again later.",
        variant: "destructive",
      });
      return { success: false };
    } finally {
      setIsLoading(false);
    }
  };

  return {
    subscribeToEmail,
    isLoading,
  };
};